// src/pages/OtpPage.tsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import OtpInput from "../components/otpinput/OtpInput";
import "../styles/OtpVerification.css"
import Dialog, { DialogProps } from "../components/dialog/Dialog";

interface LocationState {
    mobile: string;
}

const OtpVerification: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { setToken } = useAuth();
    const state = location.state as LocationState;

    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const [otpError, setOtpError] = useState<boolean>(false);
    const [alert, setAlert] = useState<DialogProps | null>(null);

    if (!state?.mobile) {
        navigate("/");
        return null;
    }

    const handleVerifyOtp2 = async () => {
        navigate("/signup", { state: { mobile: state.mobile, token: "sdfjhsdjfdjfds" } });
    }


    const handleVerifyOtp = async () => {
        if (!otp && otp.length < 4) return setOtpError(true)
        try {
            setLoading(true);
            const res = await axios.post("https://uragate.in/websites/springapi/driver-registration/v1/auth/login/verify-otp", {
                mobileNumber: state.mobile,
                otpCode: otp,
            });
            const data = res.data;
            if (data) {
                console.log(data);
                const token = data.token;
                const route = data.route;
                if (route == "signup") {
                    navigate("/signup", { state: { mobile: state.mobile, token } });
                } else {
                    localStorage.setItem("token", token);
                    setToken(token);
                    navigate("/dashboard");
                }

            } else {
                setAlert({
                    type: "error",
                    title: "Error",
                    message: "Verification failed.",
                    btnName: "Okay",
                    onClick() {
                        setAlert(null)
                    },
                });
            }
        } catch (error: any) {
            console.error(error);
            setAlert({
                type: "error",
                title: "Error",
                message: error.response?.data?.message || "Verification failed.",
                btnName: "Okay",
                onClick() {
                    setAlert(null)
                },
            });
        } finally {
            setLoading(false);
        }
    };

    const handleOtpChange = (value: string) => {
        setOtp(value)
        if (value.length < 4) {
            setOtpError(false)
        }
    }

    return (
        <div className="otp-ver-page">
            <div className="spacer"></div>
            <div className="otp-ver-main-container">
                <div className="otp-ver-content-container">
                    <h2>Verify Mobile</h2>
                    <p>OTP has sent to {state.mobile}</p>
                </div>
                <OtpInput onChange={handleOtpChange} isLoading={false} error={otpError} />
                <button className={`otp-verify-btn`} disabled={loading} onClick={handleVerifyOtp}>{loading ? "Verifying..." : "Verify"}</button>
            </div>
            <div className="spacer"></div>
            {alert && <Dialog type={alert.type} title={alert.title} message={alert.message} btnName={alert.btnName} onClick={alert.onClick} />}
        </div>
    );
};

export default OtpVerification;
